<template>
  <i-card am-filter-item :style="`max-height:${screenHeight - 300}px`">
    <template v-if="store.state.filter.selected.length">
      <div
        class="_display:flex _align-items:center _margin-top:1/2 _flex:wrap _position:relative _padding-right:1"
        v-for="(item, index) in store.state.filter.selected"
        :key="item"
      >
        {{ index === 0 ? 'Where' : 'and'}}
        <ISelect
          size="sm"
          v-model="store.state.filter.selected[index]"
          @update:modelValue="(event) => {
            store.dispatch('filter/updateFilter', {
              index: index,
              col: event,
              subtable: $route.params.subtable
            })
          }"
          :options="coll"
          label="name"
          placeholder="Choose field.."
          autocomplete
          @search="(event) => searchColl = event"
          class="_margin-right:1/2 _margin-left:1/2"
        />
        {{ item.category === 'static' || item.category === 'field' ? 'contain' : 'any off' }}
        <div
          v-if="item.category === 'static' || item.category === 'field'"
          class="_margin-left:1/2"
        >
          <IInput
            size="sm"
            v-model="item.values"
            placeholder="Enter a value"
            @change="pushChanges()"
          />
        </div>
        <div
          v-if="item.category === 'fieldsArray'"
          class="_margin-left:1/2 _display:flex _flex:wrap _align-items:center"
        >
          <div
            v-for="(algoritm, algIndex) in item.values"
            :key="algIndex"
            class="_display:inline-flex _align-items:center _margin-bottom:1 _margin-top:1 _margin-right:1/2"
          >
            <algorithm-input
              :alg="item.values[algIndex]"
              @update="(n)=> {
                item.values[algIndex] = n.data;
                if (n.error) return;
                pushChanges()
              }"
              @delete="() => {
                item.values.length === 1 ? item.values[0] = '' : item.values.splice(algIndex, 1);
                pushChanges()
              }"
            />
          </div>
          <svg
            am-icon
            viewBox="0 0 24 24"
            class="_margin-bottom:1/3"
            style="min-width:1rem"
            @click="item.values.push('')"
          >
            <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
          </svg>
        </div>
        <div
          v-if="item.category === 'params' || item.category === 'paramssArray'"
          class="_margin-left:1/2 _display:flex _flex:wrap _margin-bottom:1/2"
        >
          <div
            v-for="(param, i) in item.values"
            :key="param"
            class="_display:flex"
            style="margin-bottom: 24px; margin-top: 24px"
          >
            <div class="_position:relative _display:flex" style="height: 42px;">
              <input-condition
                v-model="param.key"
                placeholder="key"
                @change="pushChanges()"
              />
              <p class="_margin-left:1"></p>
              <input-condition
                v-if="item.category === 'params'"
                v-model="param.value"
                @change="pushChanges()"
                type="number"
                placeholder="value"
              />
              <ITextarea
                v-else
                v-model="param.value"
                @keypress="watchValue"
                @change="pushChanges()"
                placeholder="Value"
              />
            </div>
            <svg
              viewBox="0 0 24 24"
              am-icon
              style="fill: var(----color); height: 40px;"
              class="_margin-left:1/2"
              @click="() => {
                delParam(i, item.values);
                pushChanges()
              }"
            >
              <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
            </svg>
            <i-button
              class="_margin-left:1"
              v-if="item.values.length - 1 === i"
              @click="item.values.push({ key: '', value: '' })"
            >
              AND
            </i-button>
            <div v-else class="_margin-left:1 _margin-right:1" style="line-height: 40px;">and</div>
          </div>
        </div>
        <template v-if="item.category === 'attr'">
          <i-badge
            color="primary"
            v-for="(attr, index) in item.values"
            :key="index"
            :am-tag-badge="attr.id % 10"
            class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
          >
            <p>
              {{
                (attr.type[0].toUpperCase() +
                attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
                ' : ' + attr.name
              }}
            </p>
            <div class="_display:flex _align-items:center">
              <svg
                viewBox="0 0 24 24"
                am-icon
                style="fill: var(----color);"
                @click="()=>{
                  item.values.splice(index, 1);
                  pushChanges()
                }"
              >
                <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
              </svg>
            </div>
          </i-badge>
          <div class="_width:100%">
            <hr />
            <div
              v-if="filterAttrs(index)"
              class="_padding-bottom:1/2 _display:flex _flex-wrap:wrap _align-items:center"
              am-attr-result
            >
              <i-badge
                size="sm"
                color="primary"
                v-for="attr in filterAttrs(index)"
                :key="attr.id"
                :am-tag-badge="attr.id % 10"
                class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
                style="cursor:pointer"
                @click="() => {
                  item.values.push(attr);
                  pushChanges()
                }"
              >
                <p style="cursor:pointer">
                  {{
                    (attr.type[0].toUpperCase() +
                    attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
                    ' : ' + attr.name
                  }}
                </p>
              </i-badge>
            </div>
            <div
              v-if="filterAttrs(index).length === 0"
              class="_padding:1/2"
            >
              No results
            </div>
          </div>
        </template>
        <div
          v-if="item.category === 'allowed_params'"
          class="_width:100% _display:flex _padding-top:1/2"
        >
          <div v-for="(value, name) in item.values" :key="name">
            <p class="_margin:0">
              {{ value.name }}
            </p>
            <i-checkbox-group
              v-model="value.selected"
            >
              <i-checkbox
                v-for="(facing, index) in value.possible"
                :key="index"
                :value="index"
                @change="pushChanges()"
                class="_margin-y:1/2 _border-color:light"
                size="sm"
              >
                <p>{{ index}} ({{ facing }})</p>
              </i-checkbox>
            </i-checkbox-group>
          </div>
        </div>
        <svg
          am-icon
          class="_margin-rigth:1/2 _margin-top:1/2 _position:absolute"
          style="top:0; right:0;"
          @click="() => {
            store.commit('filter/delCol', index);
            pushChanges('del')
          }"
        >
          <use xlink:href="@/assets/icons.svg#delete2"></use>
        </svg>
        <template v-if="index + 1 < store.state.filter.selected.length">
          <hr class="_width:100%" />
        </template>
      </div>
    </template>
    <div v-else>
      No filter conditions are applied
    </div>
    <div class="_display:flex _justify-content:space-between _margin-top:1/2">
      <i-button
        link
        color="primary"
        @click="store.dispatch('filter/selectCol', {
          col: coll[0],
          subtable: $route.params.subtable
        })"
        class="_padding:0"
      >
        Add conditions
      </i-button>
      <i-button
        v-if="store.state.filter.selected.length"
        link
        :color="
          inkline.options.colorMode === 'dark' || darkMode ? 'light' : 'dark'"
        @click="reset()"
        class="_padding:0"
      >
        Reset filter
      </i-button>
    </div>
  </i-card>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted, onUnmounted, ref, inject } from 'vue'
import { useStore } from 'vuex'
import algorithmInput from './instructions/algorithmInput.vue'
import inputCondition from './instructions/inputCondition.vue'

const inkline = inject('inkline')
const route = useRoute()
const router = useRouter()
const store = useStore()

const darkMode = computed(() => {
  if (document.body.classList.contains('-dark')) {
    return true
  } else return false
})

const screenHeight = screen.height

const reset = () => {
  store.commit('filter/resetFilter')
  router.push({
    query: {}
  })
}
const pushChanges = (action) => {
  store.dispatch('filter/filterPart', { subtable: route.params.subtable })
  if (action === 'del' && !store.state.filter.selected.length) {
    router.push({
      query: {}
    })
  } else {
    router.push({
      query: {
        filter: JSON.stringify(store.state.filter.selected)
      }
    })
  }
}

const searchColl = ref(null)
const coll = computed(() => {
  return store.state.parts.data[route.params.subtable].columns.filter(el => {
    if (searchColl.value) {
      return (
        el.category !== 'image' &&
        el.category !== 'children' &&
        el.type !== 'index' &&
        el.name.toLowerCase().includes(searchColl.value?.toLowerCase())
      )
    } else {
      return el.category !== 'image' && el.category !== 'children' && el.type !== 'index'
    }
  })
})

const close = () => {
  store.state.filter.isShowFilter = false
}
onMounted(() => {
  store.commit('ui/closeModal', close)
})
onUnmounted(() => {
  store.commit('ui/closeModal', null)
})

// params

const watchValue = (event) => {
  const regex = /^[0-9 ,]+$/
  const key = String.fromCharCode(!event.charCode ? event.which : event.charCode)
  if (!regex.test(key)) {
    event.preventDefault()
    return false
  }
}
const delParam = (index, value) => {
  if (value.length === 1) {
    value[0].value = ''
    value[0].key = ''
  } else {
    value.splice(index, 1)
  }
}

// attr
const attrs = computed(() => {
  if (
    store.state.attributes.allAttrInCol &&
    store.state.attributes.allAttrInCol[route.params.subtable]
  ) {
    return store.state.attributes.allAttrInCol[route.params.subtable]
  } else return false
})
const filterAttrs = (index) => {
  const colIndex = store.state.filter.selected[index].colIndex
  if (attrs.value[colIndex]) {
    return attrs.value[colIndex].filter((elem) => {
      return !store.state.filter.selected[index].values?.find(({ id }) => elem.id === id)
    })
  } else return false
}
</script>

<style lang="scss">
  [am-filter-item] {
    .checkbox {
      cursor: default;
      .checkbox-label {
        overflow: hidden;
        cursor: pointer;
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 0;
        }
        &::before {
          min-width: var(----size);
          border-color: var(----border-color--checked);
        }
      }
    }
    overflow: auto;
    min-width: 40rem !important;
  }
</style>
